import React from "react";
import { ChevronDown } from "lucide-react";
const menuItems = [
  { label: "Features", item1: "ITEM1", item2: "ITEM2" },
  { label: "Resources", item1: "ITEM1", item2: "ITEM2" },
  { label: "Company", item1: "ITEM1", item2: "ITEM2" },
];
const Header = () => {
  return (
    <div className=" border-b">
      <div className="flex justify-between mx-5 lg:mx-20 py-4 items-center">
        <div className="logo text-lg font-semibold text-[#121B26]">SuperMetrics.com</div>
        <div className="navigation">
          <nav className="flex hidden md:flex lg:space-x-4">
            {menuItems.map((item, index) => (
              <div key={index} className="relative group">
                <button className="text-blue-600 font-medium flex items-center space-x-1 hover:scale-105 transition-transform duration-300 ">
                  <span className="text-sm font-semibold text-[#42526B]">{item.label}</span>
                  <ChevronDown className="w-4 text-[#42526B] h-4 group-hover:rotate-180 transition-transform" />
                </button>

                <div className="absolute left-0 hidden group-hover:block bg-white shadow-md rounded-lg">
                  <ul className="py-2">
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <p>{item.item1}</p>
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <p>{item.item2}</p>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
            <button className="text-blue-600 font-medium flex items-center space-x-1 hover:scale-105 transition-transform duration-300 ">
              <span className="text-sm font-semibold text-[#42526B]">Pricing</span>
            </button>
          </nav>
        </div>
        <div className="navigation-actions space-x-4 flex">
            <a href="/" className="text-sm font-semibold text-[#212F40] my-auto hover:scale-105 transition-transform duration-300 ">Log in</a>
            <button className="text-sm font-semibold bg-[#1b91f0] rounded-xl py-3.5 px-4 text-white hover:bg-blue-500 transition-transform duration-300 ">Sign up</button>
        </div>
      </div>
    </div>
  );
};

export default Header;
